module.exports = __webpack_public_path__ + "static/img/newStock0.53bd1e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/newStock/newStock0.jpg
// module id = CKVE
// module chunks = 1